/* eslint-disable @typescript-eslint/naming-convention */
import { Pipe, PipeTransform } from '@angular/core';
import { RoundingRule } from '~core/models/currency.models';

@Pipe({
  name: 'roundingRule',
  standalone: true,
  pure: true
})
export class RoundingRuleLabelPipe implements PipeTransform {
  private readonly _ruleMap: Record<RoundingRule, string> = {
    rounded_down: 'Arrondi au plus proche (normal)',
    rounded_to_the_nearest_whole_number: 'Arrondi au plus grand (par excès)',
    rounded_to_the_nearest: 'Arrondi au plus petit (par défaut)'
  };

  transform(rule: RoundingRule | null | undefined): string {
    if (!rule) return '-';
    return this._ruleMap[rule] || rule;
  }
}
